<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelSecao"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="preselectFirst"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :loading="isLoading"
  >
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: {
    nameField: {},
    localidadeSelected: {},
    empresaSelected: {},
    isRequired: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    emptyLabel: { type: String, default: null },
    includeAll: { type: Boolean, default: false },
    isObject: { type: Boolean, default: false },
    preselectFirst: { type: Boolean, default: false }
  },

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_secao', null);
        return;
      }
      this.isObject ? this.$emit('selectChange', 'id_secao', e) : this.$emit('selectChange', 'id_secao', e.id);
    },
    setValue(value) {
      if (value) {
        this.selected = this.options.find((option) => option.id === value);
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.preselectFirst ? this.preselectFirstCheck() : null;
      this.onChange(this.selected);
      this.$emit('input', this.selected);
    },

    preselectFirstCheck() {
      this.selected = this.options[0];
    },

    setOptions(filtros) {
      if (!filtros.localidadeId) return;
      this.isLoading = true;
      this.$atenaList
        .getSecoes({
          columns: 'id, numero, nome',
          filter: `business_logic.secao.id_empresa=${
            filtros.empresaId || this.$store.state.user.info.id_empresa
          } and business_logic.secao.id_localidade=${
            filtros.localidadeId
          } and business_logic.secao.excluido=false`,
          order: 'numero'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    labelSecao({ nome, numero }) {
      return numero ? `${numero} - ${nome}` : `${nome}`;
    }
  },

  watch: {
    empresaSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions({ empresaId: newVal, localidadeId: this.localidadeSelected });
      }
    },
    localidadeSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions({ empresaId: this.empresaSelected, localidadeId: newVal });
      }
    }
  },

  created() {
    if (this.localidadeSelected)
      this.setOptions({ empresaId: this.empresaSelected || null, localidadeId: this.localidadeSelected });
  }
};
</script>

<style lang="scss" scoped></style>
